import React from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import IE from "../../../../components/Formatters/IE";
import CNPJ from "../../../../components/Formatters/CNPJ";
import { formatarData } from "../../../../components/Formatters/DateTime";
import useConsultaRefc from "../hooks/useConsultaRefc";

const ConsultaRefc = ({ dadosOs }) => {
  const { ocorrencias, handleImprimirRelatorio } = useConsultaRefc({ dadosOs });
  return (
    <>
      <Row>
        <Col>
          <h4>Ocorrência REFC</h4>
        </Col>
        <Col className="text-right">
          <Button
            variant="primary"
            className="font-weight-bold text-center tamanho-fonte-botao"
            onClick={() => handleImprimirRelatorio(dadosOs?.inscricaoEstadual, dadosOs?.razaoSocial, dadosOs?.cnpjCpf)}
          >
            Visualizar Impressão
          </Button>
        </Col>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Dados do Contribuinte</b>
            </div>
            <div className="card-body col-sm-12">
              <Form.Group as={Col} md={12}>
                <Row>
                  <Form.Group as={Col} md={6}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>Razão Social</b>
                      </Form.Label>{" "}
                      <br />
                    </div>
                    <div className="form-inline">
                      <Form.Label>{dadosOs?.razaoSocial}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={3}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>CNPJ</b>
                      </Form.Label>
                    </div>
                    <div className="form-inline">
                      <Form.Label>
                        <CNPJ value={dadosOs?.cnpjCpf} />
                      </Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={3}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>Inscrição Estadual</b>
                      </Form.Label>{" "}
                      <br />
                    </div>
                    <div className="form-inline">
                      <Form.Label>
                        <IE value={dadosOs.inscricaoEstadual} />
                      </Form.Label>
                    </div>
                  </Form.Group>
                </Row>
                {ocorrencias?.length > 0 && ocorrencias[0] !== null ? (
                  <Row>
                    <div>
                      <table className="table table-striped table-bordered" width="90%">
                        <thead>
                          <tr>
                            <th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Ocorrência
                            </th>
                            <th colSpan={4} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Inclusão
                            </th>
                            <th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Base Legal
                            </th>
                            <th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Ato Concessório
                            </th>
                            <th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Núm. do Processo
                            </th>
                            <th colSpan={4} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Baixa
                            </th>
                          </tr>
                          <tr>
                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Data</th>
                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Usuário</th>
                            <th colSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Justificativa
                            </th>
                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Data</th>
                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Usuário</th>
                            <th colSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                              Justificativa
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ocorrencias?.map((ocorrencia) => (
                            <tr>
                              <td>
                                {ocorrencia?.sequencialOcorrencia} - {ocorrencia?.descricaoOcorrencia}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {ocorrencia.dataInicio === "0001-01-01T00:00:00"
                                  ? ""
                                  : formatarData(ocorrencia.dataInicio, "dd/MM/yyyy")}
                              </td>
                              <td>{ocorrencia.codigoUsuarioInclusao}</td>
                              <td colSpan={2}>{ocorrencia.textoInclusao}</td>
                              <td>{ocorrencia.textoBaseLegal}</td>
                              <td>{ocorrencia.textoAtoConcessorio}</td>
                              <td>{ocorrencia.numeroProtocoloGeral}</td>
                              <td style={{ textAlign: "center" }}>
                                {ocorrencia.dataBaixa === "0001-01-01T00:00:00"
                                  ? ""
                                  : formatarData(ocorrencia.dataBaixa, "dd/MM/yyyy")}
                              </td>
                              <td>{ocorrencia.codigoUsuarioBaixa}</td>
                              <td colSpan={2}>{ocorrencia.textoBaixa}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Row>
                ) : (
                  <b>Nenhum registro para exibir</b>
                )}
              </Form.Group>
            </div>
          </div>
        </div>
      </Row>
    </>
  );
};

export default ConsultaRefc;
